import { useMemo } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {
  fileRenderKeyState,
  prefixState,
  S3File,
  selectCocoonsState,
  selectModelsState,
  selectMorphedState,
  selectTiresState,
  selectWheelhousesState
} from 'features/file-browser/state/fileAtoms';
import { CustomButton } from 'shared/ui/CustomButton';
import { handleDeleteButtonClick } from '../utils/deleteButtonClick';

export const DeleteButton: React.FC = () => {
  const prefix = useRecoilValue(prefixState);
  const selectModels = useRecoilValue(selectModelsState);
  const selectCocoons = useRecoilValue(selectCocoonsState);
  const selectTires = useRecoilValue(selectTiresState);
  const selectWheelhouses = useRecoilValue(selectWheelhousesState);
  const selectMorphed = useRecoilValue(selectMorphedState);
  const setRenderKey = useSetRecoilState(fileRenderKeyState);

  const filesToDelete = useMemo<S3File[]>(() => {
    switch (prefix) {
      case "model": return selectModels;
      case "cocoon": return selectCocoons;
      case "tire": return selectTires;
      case "wheelhouse": return selectWheelhouses;
      case "morphed": return selectMorphed;
      default: return [];
    }
  }, [prefix, selectModels, selectCocoons, selectTires, selectWheelhouses, selectMorphed]);

  const disable = filesToDelete.length === 0;

  return (
    <CustomButton
      sx={{ fontSize: '10px', width: '100%' }}
      size="small"
      onClick={() => handleDeleteButtonClick(filesToDelete, setRenderKey)}
      startIcon={<DeleteOutlineIcon />}
      disabled={disable}
    >
      Delete
    </CustomButton>
  );
};
